(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var root = document.getElementById('ceSuri');
  var reduce = false;
  var cfgEl = document.querySelector('[data-ce-suri-data]') || document.querySelector('[data-cc-cfg]');
  var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};

  /* ---------- menu ---------- */
  var menu = document.querySelector('[data-menu]');
  document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu && menu.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }); });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu && menu.classList.remove('is-open'); document.documentElement.style.overflow = ''; }); });

  /* ---------- accordions / faq ---------- */
  document.querySelectorAll('[data-acc] > div').forEach(function (item) {
    var btn = item.querySelector('button'), panel = btn && btn.nextElementSibling;
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
    });
  });

  /* ---------- lazy videos ----------
     Sources are attached when a video nears the screen. Playback is retried when the data arrives, when the tab or app
     comes back to the front, and on the next tap (phones that block autoplay, e.g. Low Power Mode, only allow it then). */
  var vids = [].slice.call(document.querySelectorAll('video[data-lazyvideo]'));
  var setPoster = function (v) { if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); };
  var prime = function (v) {
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    setPoster(v);
    if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; v.load(); }
  };
  var kick = function (v) {
    if (!v._want || v._userPaused || document.hidden) return;
    prime(v);
    if (!v.paused && !v.ended) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  };
  var kickAll = function () { vids.forEach(kick); };
  vids.forEach(function (v) {
    ['loadeddata', 'canplay'].forEach(function (ev) { v.addEventListener(ev, function () { kick(v); }); });
    v.addEventListener('error', function () { if (v._retried || !v.dataset.src) return; v._retried = true; setTimeout(function () { v.src = v.dataset.src; v.load(); kick(v); }, 1200); });
  });
  if ('IntersectionObserver' in window) {
    /* a rail clips the tiles that are scrolled out sideways, so once one tile is near, every tile in that rail gets its poster */
    var pio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; var rail = e.target.closest('.cs-ugc__track,.cs-carousel__track'); (rail ? [].slice.call(rail.querySelectorAll('video[data-lazyvideo]')) : [e.target]).forEach(function (v) { setPoster(v); pio.unobserve(v); }); }); }, { rootMargin: '900px 0px' });
    vids.forEach(function (v) { pio.observe(v); });
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v._want = e.isIntersecting;
        if (e.isIntersecting) kick(v); else if (!v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    var gio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v._want = e.isIntersecting && e.intersectionRatio >= 0.6;
        if (v._want) kick(v); else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.6] });
    vids.forEach(function (v) { (v.closest('.cs-gallery__slide') ? gio : vio).observe(v); });
  } else { vids.forEach(function (v) { v._want = true; kick(v); }); }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) kickAll(); });
  window.addEventListener('pageshow', kickAll);
  ['touchend', 'click'].forEach(function (ev) { document.addEventListener(ev, kickAll, { passive: true }); });

  /* ---------- labels banner (SURI: stagger in at 50% viewport, out when above) ---------- */
  var banner = document.querySelector('[data-banner]');
  if (banner) {
    var labels = banner.querySelectorAll('.cs-label'), wrap = banner.querySelector('[data-labels]'), active = false;
    var labelExit = document.documentElement.getAttribute('dir') === 'rtl' ? 'translateX(100%)' : 'translateX(-100%)';
    var animIn = function () { labels.forEach(function (l, i) { setTimeout(function () { l.style.transition = 'opacity .6s ease-out, transform .6s ease-out'; l.style.opacity = '1'; l.style.transform = 'translateX(0)'; }, i * 300); }); };
    var animOut = function () { labels.forEach(function (l, i) { setTimeout(function () { l.style.transition = 'opacity .3s ease-in, transform .3s ease-in'; l.style.opacity = '0'; l.style.transform = labelExit; }, i * 100); }); };
    var check = function () {
      var r = banner.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) banner.classList.add('zoomed');
      var t = wrap.getBoundingClientRect().top, trig = window.innerHeight / 2;
      if (t <= trig && !active) { active = true; animIn(); } else if (t > trig && active) { active = false; animOut(); }
    };
    if (reduce) { labels.forEach(function (l) { l.style.opacity = '1'; l.style.transform = 'none'; }); }
    else { window.addEventListener('scroll', check, { passive: true }); check(); }
    var bt = banner.querySelector('[data-banner-toggle]'), bv = banner.querySelector('video');
    var toggle = function (e) { if (!bv) return; if (e) e.stopPropagation(); if (bv.paused) { bv._userPaused = false; var bp = bv.play(); if (bp && bp.catch) bp.catch(function () {}); bt.style.opacity = '1'; } else { bv._userPaused = true; bv.pause(); bt.style.opacity = '.6'; } };
    bt && bt.addEventListener('click', toggle); bv && bv.addEventListener('click', toggle);
  }

  /* autoplay helper: runs only while the rail is on screen, pauses after any user input */
  var autoRail = function (host, tr, tick, ms) {
    var seen = false, hold = 0, pause = function () { hold = Date.now() + 9000; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'mouseenter'].forEach(function (ev) { host.addEventListener(ev, pause, { passive: true }); });
    host.addEventListener('mouseleave', function () { hold = Date.now() + 2500; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { seen = e[0].isIntersecting; }, { threshold: 0.4 }).observe(host); else seen = true;
    setInterval(function () { if (seen && !document.hidden && Date.now() > hold) tick(); }, ms);
    return pause;
  };

  /* ---------- carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var tr = c.querySelector('[data-track]'); if (!tr) return;
    var gapw = function () { var card = tr.firstElementChild; return card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(tr).columnGap) || 14) : 300; };
    var step = function (d) {
      var em = tr.ceEmbla;
      if (em) { if (d > 0) { if (em.canScrollNext()) em.scrollNext(); else em.scrollTo(0); } else if (em.canScrollPrev()) em.scrollPrev(); else em.scrollTo(em.scrollSnapList().length - 1); return; }
      var max = tr.scrollWidth - tr.clientWidth;
      if (d > 0 && tr.scrollLeft >= max - 4) tr.scrollTo({ left: 0, behavior: 'smooth' });
      else if (d < 0 && tr.scrollLeft <= 4) tr.scrollTo({ left: max, behavior: 'smooth' });
      else tr.scrollBy({ left: d * gapw(), behavior: 'smooth' });
    };
    var p = c.querySelector('[data-prev]'), n = c.querySelector('[data-next]');
    p && p.addEventListener('click', function () { step(-1); }); n && n.addEventListener('click', function () { step(1); });
    if (c.classList.contains('cs-adv') && tr.children.length > 1) autoRail(c, tr, function () { if (tr.ceEmbla ? tr.ceEmbla.scrollSnapList().length > 1 : tr.scrollWidth > tr.clientWidth + 8) step(1); }, 4200);
  });

  /* ---------- doorway read more ---------- */
  document.querySelectorAll('[data-flip]').forEach(function (card) {
    var b = card.querySelector('[data-more]');
    b && b.addEventListener('click', function () { var on = card.classList.toggle('is-flipped'); b.textContent = on ? ((cfg.t && cfg.t.close) || 'CLOSE') : ((cfg.t && cfg.t.read_more) || 'READ MORE'); });
  });

  /* ---------- press slider: dots, drag, autoplay ---------- */
  document.querySelectorAll('[data-press]').forEach(function (p) {
    var tr = p.querySelector('[data-press-track]'), dots = [].slice.call(p.querySelectorAll('[data-press-dots] i'));
    if (!tr || !dots.length) return;
    var idx = function () { return Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); };
    var goTo = function (i) { var n = dots.length; i = ((i % n) + n) % n; tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); };
    tr.addEventListener('scroll', function () { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('on', k === i); }); }, { passive: true });
    dots.forEach(function (d, k) { d.setAttribute('role', 'button'); d.setAttribute('tabindex', '0'); d.setAttribute('aria-label', (cfg.t && cfg.t.press_quote ? cfg.t.press_quote.replace('[index]', k + 1) : 'Press quote ' + (k + 1))); d.addEventListener('click', function () { goTo(k); }); d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goTo(k); } }); });
    autoRail(p, tr, function () { goTo(idx() + 1); }, 4800);
  });

  /* reviews: show photo reviews first */
  (function () { var tries = 0, t = setInterval(function () { var sel = document.querySelector('#judgeme_product_reviews select'); if (sel) { clearInterval(t); if (sel.value !== 'pictures_first' && [].some.call(sel.options, function (o) { return o.value === 'pictures_first'; })) { sel.value = 'pictures_first'; sel.dispatchEvent(new Event('change', { bubbles: true })); } } else if (++tries > 40) clearInterval(t); }, 500); })();

  if (!root) return;
  /* ---------- product state ---------- */
  var dataEl = root.querySelector('[data-ce-suri-data]');
  var D = JSON.parse(dataEl.textContent);
  var byKey = {}; D.variants.forEach(function (v) { byKey[v.key || v.title] = v; });
  var colours = D.variants.map(function (v) { return v.key || v.title; });
  var sel = (D.variants.filter(function (v) { return v.id === D.selected; })[0] || D.variants[0]).key || (D.variants.filter(function (v) { return v.id === D.selected; })[0] || D.variants[0]).title;
  var offer = 3, seenOffers = false;
  var PRE = { 1: ['Beige'], 3: ['Beige', 'Black', 'Blue'], 5: ['Beige', 'Black', 'Blue', 'Gray', 'Pink'] };
  var PAY = { 1: 1, 3: 2, 5: 3 };
  var pickFor = function (n) { return PRE[n].map(function (t) { return byKey[t] && byKey[t].available ? t : sel; }); };
  var picksBy = { 1: pickFor(1), 3: pickFor(3), 5: pickFor(5) };
  var picks = picksBy[3]; sel = picks[0];
  var setAll = function (c) { sel = c; [1, 3, 5].forEach(function (n) { picksBy[n] = picksBy[n].map(function () { return c; }); }); picks = picksBy[offer]; };

  /* whole amounts without .00 / ,00 (owner: clean numbers) */
  var money = function (cents) { var out = moneyFull(cents); return cents % 100 === 0 ? out.replace(/([.,])00(?!\d)/, '') : out; };
  var moneyFull = function (cents) {
    var fmt = D.moneyFormat || '${{amount}}';
    var f = function (n, dec, th, dp) { var s = (n / 100).toFixed(dec).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return s[0] + (s[1] ? dp + s[1] : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return f(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return f(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return f(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return f(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return f(cents, 2, ' ', '.');
        default: return f(cents, 2, ',', '.');
      }
    });
  };
  var sw = function (key, small, active, onClick) {
    var v = byKey[key] || {};
    var label = v.title || key;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'cs-sw' + (small ? ' cs-sw--sm' : '') + (active ? ' is-active' : '');
    b.style.background = D.hex[key] || '#ccc'; b.setAttribute('aria-label', label); b.title = label;
    if (byKey[key] && !byKey[key].available) { b.style.opacity = '.35'; b.disabled = true; }
    b.addEventListener('click', function (e) { e.stopPropagation(); onClick(key); });
    return b;
  };

  var gallery = root.querySelector('[data-gallery]'), dots = root.querySelector('[data-dots]');
  var goSlide = function (t) { var i = D.slideFor[t]; var s = gallery && gallery.children[i]; if (s) gallery.scrollTo({ left: s.offsetLeft - gallery.children[0].offsetLeft, behavior: 'smooth' }); };

  var mainSw = root.querySelector('[data-main-swatches]');
  var renderMain = function () {
    if (mainSw) mainSw.innerHTML = ''; dots.innerHTML = '';
    colours.forEach(function (t) {
      if (mainSw) mainSw.appendChild(sw(t, false, t === sel, function (c) { setAll(c); goSlide(c); renderAll(); }));
      var d = document.createElement('button'); d.type = 'button'; d.className = 'cs-dot' + (t === sel ? ' is-active' : ''); d.style.background = D.hex[t]; d.setAttribute('aria-label', (byKey[t] && byKey[t].title) || t);
      d.addEventListener('click', function () { setAll(t); goSlide(t); renderAll(); }); dots.appendChild(d);
    });
  };
  var renderRows = function () {
    root.querySelectorAll('.cs-offer').forEach(function (card) {
      var n = parseInt(card.dataset.offer, 10), rows = card.querySelector('[data-rows]');
      rows.innerHTML = '';
      if (n !== offer) return;
      for (var i = 0; i < n; i++) {
        (function (idx) {
          var row = document.createElement('div'); row.className = 'cs-crow';
          row.setAttribute('role', 'group'); row.setAttribute('aria-label', (D.t && D.t.umbrella_colour ? D.t.umbrella_colour.replace('[index]', idx + 1) : 'Umbrella ' + (idx + 1) + ' colour'));
          var list = document.createElement('div'); list.className = 'cs-swatches';
          colours.forEach(function (t) { list.appendChild(sw(t, true, picks[idx] === t, function (c) { picks[idx] = c; goSlide(c); renderAll(); })); });
          var th = document.createElement('img'); th.className = 'cs-crow__img'; th.alt = ''; th.src = D.umb[picks[idx]] + '&width=160';
          var nm = document.createElement('span'); nm.className = 'cs-crow__name'; nm.textContent = (byKey[picks[idx]] || {}).title || picks[idx];
          var rr = document.createElement('div'); rr.className = 'cs-crow__r'; rr.appendChild(nm); rr.appendChild(list);
          row.appendChild(th); row.appendChild(rr); rows.appendChild(row);
        })(i);
      }
    });
  };
  var totalEl = root.querySelector('[data-total]');
  var renderStacks = function () {
    root.querySelectorAll('.cs-offer').forEach(function (card) {
      var n = parseInt(card.dataset.offer, 10), box = card.querySelector('.cs-offer__img');
      var key = picksBy[n].join('|'); if (box.dataset.key === key) return; box.dataset.key = key;
      box.className = 'cs-offer__img cs-stack cs-stack--' + n; box.innerHTML = '';
      picksBy[n].forEach(function (t, i) { var v = byKey[t] || {}; var label = v.title || t; var im = document.createElement('img'); im.src = D.umb[t] + '&width=160'; im.alt = D.t && D.t.umbrella_alt ? D.t.umbrella_alt.replace('[colour]', function () { return label; }) : label + ' Haven umbrella'; im.style.zIndex = String(10 - i); box.appendChild(im); });
    });
  };
  var renderAll = function () {
    renderMain(); renderRows(); renderStacks();
    root.querySelectorAll('[data-kit] [data-tier]').forEach(function (t) { var need = parseInt(t.dataset.tier, 10), locked = offer < need; t.classList.toggle('is-locked', locked); });
    root.querySelectorAll('.cs-offer').forEach(function (c) { var on = parseInt(c.dataset.offer, 10) === offer; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', String(on)); });
    var pay = D.price * PAY[offer], was = Math.max(D.compare, D.price) * offer; /* the same struck figure as the offer card: every umbrella at the full single price */
    totalEl.innerHTML = '<span>' + money(pay) + '</span>' + (was > pay ? '<s>' + money(was) + '</s>' : '');
    var sp = root.querySelector('[data-sticky-price]'); if (sp) sp.innerHTML = seenOffers ? '\u00b7 ' + money(pay) : '';
    var sl = root.querySelector('[data-sticky-label]'); if (sl) sl.textContent = seenOffers ? sl.dataset.add : sl.dataset.choose;
  };
  var setOffer = function (n) { offer = n; picks = picksBy[n]; renderAll(); };
  root.querySelectorAll('.cs-offer').forEach(function (c) {
    c.addEventListener('click', function () { setOffer(parseInt(c.dataset.offer, 10)); });
    c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOffer(parseInt(c.dataset.offer, 10)); } });
  });
  document.querySelectorAll('[data-pick-offer]').forEach(function (b) {
    b.addEventListener('click', function () { setOffer(parseInt(b.dataset.pickOffer, 10)); document.getElementById('csColour').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  });
  renderAll();

  /* gallery scroll -> active dot, counter, arrows */
  if (gallery) {
    var gcount = root.querySelector('[data-gcount]'), gwrap = gallery.closest('.cs-gallery') || gallery.parentNode, gi = 0, gtick = 0;
    var colourSlide = {}; Object.keys(D.slideFor).forEach(function (t) { colourSlide[D.slideFor[t]] = t; });
    var hydrate = function (sl) { var im = sl && sl.querySelector('img[data-src]'); if (!im) return; im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); im.removeAttribute('data-srcset'); };
    var hydrateAll = function () { [].forEach.call(gallery.children, hydrate); };
    /* speed: the page loads only the picture on screen; the next two load on the first touch of the gallery, or shortly after the page has loaded */
    var gwarm = false, gwarmUp = function () { if (gwarm) return; gwarm = true; gsync(); };
    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (ev) { gwrap.addEventListener(ev, gwarmUp, { passive: true }); });
    var gwarmLater = function () { setTimeout(gwarmUp, 2500); };
    if (document.readyState === 'complete') gwarmLater(); else window.addEventListener('load', gwarmLater);
    var gsync; gsync = function () {
      gtick = 0;
      var kids = gallery.children, x = gallery.scrollLeft, best = 0, bd = 1e9;
      for (var k = 0; k < kids.length; k++) { var d = Math.abs(kids[k].offsetLeft - kids[0].offsetLeft - x); if (d < bd) { bd = d; best = k; } }
      gi = best;
      for (var hk = Math.max(0, gi - 1); hk <= Math.min(kids.length - 1, gi + (gwarm ? 2 : 0)); hk++) hydrate(kids[hk]);
      if (gcount) gcount.textContent = (gi + 1) + ' / ' + kids.length;
      gwrap.classList.toggle('is-colour', !!colourSlide[gi]);
      gwrap.classList.toggle('at-start', gi === 0); gwrap.classList.toggle('at-end', gi === kids.length - 1);
      var t = colourSlide[gi]; if (t && t !== sel) { sel = t; renderMain(); }
    };
    gallery.addEventListener('scroll', function () { if (!gtick) gtick = requestAnimationFrame(function () { gsync(); }); }, { passive: true });
    var gstep = function (n) { var kids = gallery.children, k = Math.max(0, Math.min(kids.length - 1, gi + n)); gallery.scrollTo({ left: kids[k].offsetLeft - kids[0].offsetLeft, behavior: 'smooth' }); };
    var gp = root.querySelector('[data-gprev]'), gn = root.querySelector('[data-gnext]');
    if (gp) gp.addEventListener('click', function () { gstep(-1); });
    if (gn) gn.addEventListener('click', function () { gstep(1); });
    /* desktop thumbnails */
    var th = document.createElement('div'); th.className = 'cs-gthumbs';
    [].forEach.call(gallery.children, function (sl, k) {
      var im = sl.querySelector('img'), v = sl.querySelector('video'), b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (D.t && D.t.image ? D.t.image.replace('[index]', k + 1) : 'Image ' + (k + 1)));
      var src = im ? (im.dataset.src || im.getAttribute('src')).replace(/width=\d+/, 'width=160') : (v.getAttribute('poster') || v.dataset.poster || '');
      if (!im && src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      b.innerHTML = '<img src="' + src + '" alt="" loading="lazy" width="64" height="85">' + (v ? '<span></span>' : '');
      b.addEventListener('click', function () { gallery.scrollTo({ left: sl.offsetLeft - gallery.children[0].offsetLeft, behavior: 'smooth' }); });
      th.appendChild(b);
    });
    gwrap.appendChild(th);
    ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (ev) { gwrap.addEventListener(ev, hydrateAll, { passive: true, once: true }); });
    /* the rest of the gallery images load on the first touch, scroll or key press instead of on a timer, so they do not compete with the first paint */
    ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel'].forEach(function (ev) { window.addEventListener(ev, hydrateAll, { passive: true, once: true }); });
    var gsync0 = gsync; gsync = function () { gsync0(); [].forEach.call(th.children, function (b, k) { b.classList.toggle('is-on', k === gi); }); };
    gsync();
  }


  /* a fetch from a blank same-origin frame is not seen by the analytics add-to-cart hook, so free gift lines do not count as adds */
  window.ceQuietFetch = window.ceQuietFetch || function () {
    try {
      var f = document.getElementById('ceQuietFrame');
      if (!f) { f = document.createElement('iframe'); f.id = 'ceQuietFrame'; f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1; f.style.display = 'none'; document.body.appendChild(f); }
      return f.contentWindow.fetch.bind(f.contentWindow);
    } catch (e) { return window.fetch.bind(window); }
  };

  /* ---------- mouse drag on horizontal rails (desktop) ---------- */
  document.querySelectorAll('.cs-gallery__track,.cs-carousel__track,.cs-ugc__track,.cs-bund__track,.cs-gthumbs,.cs-press__track').forEach(function (tr) {
    var down = false, sx = 0, sl = 0, moved = false;
    tr.addEventListener('mousedown', function (e) { if (e.button !== 0 || tr.ceEmbla) return; down = true; moved = false; sx = e.pageX; sl = tr.scrollLeft; });
    window.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - sx; if (Math.abs(dx) > 4) { moved = true; tr.style.scrollSnapType = 'none'; tr.style.scrollBehavior = 'auto'; tr.scrollLeft = sl - dx; e.preventDefault(); } });
    window.addEventListener('mouseup', function () { if (!down) return; down = false; tr.style.scrollSnapType = ''; tr.style.scrollBehavior = ''; });
    tr.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    tr.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });

  /* ---------- customer video popup ---------- */
  var pop = document.querySelector('[data-vpop]');
  if (pop) {
    var pv = pop.querySelector('[data-vvideo]'), tiles = [].slice.call(document.querySelectorAll('[data-ugc]')), cur = 0, vbar = pop.querySelector('[data-vbar]'), vm = pop.querySelector('[data-vmute]');
    var vsync = function () { vm.classList.toggle('is-muted', pv.muted); };
    var vshow = function (i) {
      cur = (i + tiles.length) % tiles.length; vbar.style.width = '0%';
      pv.poster = tiles[cur].dataset.poster || ''; pv.src = tiles[cur].dataset.full; pv.load();
      var pr = pv.play(); if (pr && pr.catch) pr.catch(function () { pv.muted = true; vsync(); pv.play().catch(function () {}); });
      vsync();
    };
    var vclose = function () { pv.pause(); pv.removeAttribute('src'); pv.load(); pop.hidden = true; document.documentElement.classList.remove('cs-noscroll'); };
    tiles.forEach(function (t, i) { t.addEventListener('click', function () { pop.hidden = false; document.documentElement.classList.add('cs-noscroll'); pv.muted = false; vshow(i); }); });
    pop.querySelector('[data-vclose]').addEventListener('click', vclose);
    pop.querySelector('[data-vprev]').addEventListener('click', function () { vshow(cur - 1); });
    pop.querySelector('[data-vnext]').addEventListener('click', function () { vshow(cur + 1); });
    vm.addEventListener('click', function () { pv.muted = !pv.muted; vsync(); });
    pv.addEventListener('click', function () { if (pv.paused) pv.play(); else pv.pause(); });
    pv.addEventListener('ended', function () { vshow(cur + 1); });
    pv.addEventListener('timeupdate', function () { if (pv.duration) vbar.style.width = (pv.currentTime / pv.duration * 100) + '%'; });
    pop.addEventListener('click', function (e) { if (e.target === pop) vclose(); });
    document.addEventListener('keydown', function (e) { if (pop.hidden) return; if (e.key === 'Escape') vclose(); if (e.key === 'ArrowRight') vshow(cur + 1); if (e.key === 'ArrowLeft') vshow(cur - 1); });
  }

  /* ---------- add to cart ---------- */
  var atc = root.querySelector('[data-atc]'), msg = root.querySelector('[data-atc-msg]');
  var going = false;
  var go = function (buyNow) {
    if (going) return; going = true;
    var qty = {}, n = offer;
    for (var i = 0; i < n; i++) { var v = byKey[picks[i]] || byKey[sel]; qty[v.id] = (qty[v.id] || 0) + 1; }
    var items = Object.keys(qty).map(function (id) { return { id: +id, quantity: qty[id] }; });
    var C = window.ceSuriCart, G = window.ceGifts;
    /* the cart as it was before this add, so the gift lines can be worked out without asking for the cart again */
    var base = C && C.cart ? C.cart() : null;
    atc.disabled = true; atc.textContent = (D.t && D.t.adding) || 'Adding…'; msg.textContent = '';
    if (!buyNow && C && C.begin) C.begin(items.map(function (it) { var v = D.variants.filter(function (x) { return x.id === it.id; })[0] || {}; return { title: (D.t && D.t.title) || 'Haven Umbrella', variant: v.title || '', image: v.image || '' }; }));
    fetch((window.routes && window.routes.cart_add_url || ROOT + 'cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        /* gifts follow the shared rules (ce-gift-guard.js); they are set quietly so the add-to-cart pixel only sees the umbrellas.
           The gift update returns the whole cart, which the drawer then shows without another request. */
        var getCart = function () { return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }); };
        if (!G) return getCart();
        if (!base || !base.items) return getCart().then(function (c0) { return G.enforce(c0).then(function (res) { return res.cart; }); });
        var guess = { items: base.items.concat([{ handle: 'haven-umbrella', quantity: n, variant_id: 0 }]) };
        return G.enforce(guess).then(function (res) { return res.changed ? res.cart : getCart(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
        if (buyNow) { window.location.href = ROOT + 'checkout'; return; }
        if (C && C.done) C.done(cart); else if (C) C.open(); else window.location.href = ROOT + 'cart';
      })
      .catch(function (e) {
        if (!buyNow && C) { if (C.cancel) C.cancel(); else C.close(); }
        msg.textContent = (e && (e.description || e.message)) || (D.t && D.t.error) || 'Something went wrong. Please try again.';
      })
      .finally(function () { going = false; atc.disabled = false; atc.textContent = (D.t && D.t.add_to_cart) || 'Add to Cart'; });
  };
  atc.addEventListener('click', function () { go(false); });
  var bn = root.querySelector('[data-buynow]'); bn && bn.addEventListener('click', function () { go(true); });

  /* ---------- sticky "Pick your colour" bar ---------- */
  var sticky = root.querySelector('[data-sticky]');
  var buy = document.getElementById('csBuy'), foot = document.querySelector('.cs-footer');
  var vis = { buy: true, foot: false };
  var upd = function () { sticky.classList.toggle('is-on', !vis.buy && !vis.foot); };
  /* the bar is there from page load; until the offers have been on screen a tap goes to them instead of adding the preselected bundle */
  var offersEl = document.getElementById('csColour');
  if (offersEl && 'IntersectionObserver' in window) new IntersectionObserver(function (e, io) { if (!e[0].isIntersecting) return; seenOffers = true; io.disconnect(); renderAll(); }, { threshold: 0.2 }).observe(offersEl); else seenOffers = true;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { vis.buy = e[0].isIntersecting; upd(); }).observe(atc);
    if (foot) new IntersectionObserver(function (e) { vis.foot = e[0].isIntersecting; upd(); }).observe(foot);
  }
  root.querySelector('[data-sticky-btn]').addEventListener('click', function () { if (seenOffers || !offersEl) go(false); else offersEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
})();
